import { createAction } from '../../techstyle-shared/redux-core';

export const trackSpeedySignupPageView = createAction(
  'TRACK_SPEEDY_SIGNUP_PAGE_VIEW'
);

export const trackProductAdded = createAction('TRACK_PRODUCT_ADDED');
export const trackAddToCartError = createAction('TRACK_ADD_TO_CART_ERROR');
